import { defineAbility } from '@casl/ability';

export default defineAbility((can) => {
  var permissions = []
  
  try {
    if (typeof localStorage !== 'undefined' && localStorage.rules) {
      permissions = JSON.parse(localStorage.rules)
    }
  } catch (e) {
    permissions = []
  }

  if (permissions && typeof permissions === 'object') {
    for (var i in permissions) {
      if (permissions[i]) {
        can(permissions[i])
      }
    }
  }
});